module.exports = __webpack_public_path__ + "images/marshallai05ded1b4d39bd6fb0d6646cfdcc9e548.png";